import regexPatterns from './regexPatterns'

const isIp = url => {
    if (regexPatterns.ipv4Extended.test(url) || regexPatterns.ipv6Extended.test(url)) {
        return true
    }

    return false
}

const isPrefixOfIpv4 = url => {
    if (regexPatterns.ipv4Prefix.test(url)) {
        return true
    }

    return false
}

export default {isIp, isPrefixOfIpv4}
